import { render, staticRenderFns } from "./InspirationsPage.vue?vue&type=template&id=0d111c20&"
import script from "./InspirationsPage.vue?vue&type=script&lang=js&"
export * from "./InspirationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports